import * as React from 'react';

import {Button} from 'shells/button/button';
import {FormField} from 'shells/form/form-field';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {TextField} from 'shells/textfield/textfield';
import {Body} from 'shells/typography/body';

import {Header} from './header';

import styles from './area-code.module.css';

type Props = {
    areaCode: string;
    setAreaCode: (areaCode: string) => void;
    onGenerateNumbers: () => void;
    isGenerating: boolean;
    errorMessage: string;
};

export function AreaCode(props: Props) {
    return (
        <StackLegacy spacing={16}>
            <Header />
            <StackLegacy spacing={16}>
                <StackLegacy spacing={4}>
                    <Body as='div' size='large' isBold={true}>
                        Enter an area code
                    </Body>
                    <Body as='div'>
                        Enter the area code you’d like to use and Nutshell will populate a list of
                        phone numbers for you to select from.
                    </Body>
                </StackLegacy>
                <div className={styles.field}>
                    <FormField
                        errorMessage={props.errorMessage}
                        innerId='areaCode'
                        label='Area code'
                        isRequired={true}
                    >
                        <TextField
                            id='areaCode'
                            // @ts-expect-error
                            name='areaCode'
                            placeholder='ex. 734'
                            size='small'
                            type='number'
                            onEnter={props.onGenerateNumbers}
                            value={props.areaCode}
                            onChange={(code: string) => props.setAreaCode(code)}
                            selectOnFocus={true}
                            focusOnMount={true}
                        />
                    </FormField>
                </div>
            </StackLegacy>
            <Button
                variant='primary'
                size='big'
                disabled={props.areaCode.length !== 3}
                onClick={props.onGenerateNumbers}
            >
                {props.isGenerating ? 'Generating…' : 'Generate numbers'}
            </Button>
        </StackLegacy>
    );
}
